<template>
    <out-put-page title="Étude financière">
        <section>
            <h3>Dotations aux amortissements</h3>
            <data-table :tables="dotation" />
        </section>
        <section v-if="creditExiste">
            <h3>Tableau d’amortissement</h3>
            <data-table :tables="chargeFinanciers" />
        </section>
        <section>
            <h3>Rentabilité du projet</h3>
            <data-table :tables="cashFlow1" />
            <data-table :tables="cashFlow2" />
            <div class="grid justify-center grid-cols-2 gap-4 p-6 mt-2">
                <div class="flex flex-col items-center">
                    <h4
                        class="text-4xl font-semibold text-center text-output-primary"
                    >
                        {{ formatPrice(outPutData.iir) }}
                    </h4>
                    <div class="h-1 w-96 bg-output-secondary"></div>
                    <p class="text-3xl font-semibold text-output-primary">
                        Taux Interne de Rentabilité (TIR)
                    </p>
                </div>
                <div class="flex flex-col items-center">
                    <h4
                        class="text-4xl font-semibold text-center text-output-primary"
                    >
                        {{ formatPrice(outPutData.van) }}
                    </h4>
                    <div class="h-1 w-96 bg-output-secondary"></div>
                    <p class="text-3xl font-semibold text-output-primary">
                        Valeur Actuelle Nette au taux de 10 %
                    </p>
                </div>
                <div class="flex flex-col items-center col-span-2">
                    <h4
                        class="text-4xl font-semibold text-center text-output-primary"
                    >
                        {{
                            outPutData.delaisRecuperation === "#NAN"
                                ? "Non défini"
                                : outPutData.delaisRecuperation + " ans"
                        }}
                    </h4>
                    <div class="h-1 w-96 bg-output-secondary"></div>
                    <p class="text-3xl font-semibold text-output-primary">
                        Délai de récupération
                    </p>
                </div>
            </div>
        </section>
    </out-put-page>
</template>

<script>
import DataTable from "../components/DataTable";
import OutPutPage from "../components/OutPutPage";
import { isArrayOfZeros } from "@/utils";
import { formatPrice } from "@/utils";

export default {
    components: {
        DataTable,
        OutPutPage
    },
    props: {
        outPutData: {
            type: Object,
            required: true
        },
        investorProgramme: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dotation: {
                headers: [
                    { title: "DÈSIGNATION", type: "String" },
                    { title: "001", type: "Currency" },
                    { title: "002", type: "Currency" },
                    { title: "003", type: "Currency" },
                    { title: "004", type: "Currency" },
                    { title: "005", type: "Currency" },
                    { title: "006", type: "Currency" },
                    { title: "007", type: "Currency" },
                    { title: "008", type: "Currency" },
                    { title: "009", type: "Currency" },
                    { title: "010", type: "Currency" }
                ],
                data: []
            },
            chargeFinanciers: {
                headers: [
                    { title: " ", type: "String" },
                    { title: "Montant du crédit	", type: "Currency" },
                    { title: "Taux", type: "String" },
                    { title: "Nombre d’échéance", type: "String" },
                    { title: "Mensualités", type: "Currency" },
                    { title: "Total intérêts", type: "Currency" }
                ],
                data: []
            },
            cashFlow1: {
                headers: [
                    { title: "Périodes", type: "String" },
                    { title: "Investissement initial", type: "String" },
                    { title: "001", type: "Currency" },
                    { title: "002", type: "Currency" },
                    { title: "003", type: "Currency" },
                    { title: "004", type: "Currency" }
                ],
                data: [[], []]
            },
            cashFlow2: {
                headers: [
                    { title: "Périodes", type: "String" },
                    { title: "005", type: "Currency" },
                    { title: "006", type: "Currency" },
                    { title: "007", type: "Currency" },
                    { title: "008", type: "Currency" },
                    { title: "009", type: "Currency" },
                    { title: "010", type: "Currency" }
                ],
                data: [[], []]
            },
            creditExiste: false
        };
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price);
        }
    },
    mounted() {
        const amortissement = [
            {
                title: "Immobilisations Corporelles",
                key: "IMMOBILISATIONS_CORPORELLES"
            },
            {
                title: "Frais d’approche",
                key: "FRAIS_APPROCHE"
            },
            {
                title: "Total",
                key: "TOTAL"
            }
        ];
        let amortissementCounter = 0;
        amortissement.forEach(elem => {
            if (isArrayOfZeros(this.outPutData.amortissements, `${elem.key}`))
                return;
            this.dotation.data.push([`${elem.title}`]);
            this.outPutData.amortissements.forEach(item => {
                this.dotation.data[amortissementCounter].push(
                    item[`${elem.key}`]
                );
            });
            amortissementCounter++;
        });

        /**
         * compatibility layers for old bips that have only one crédite
         * parse tableauAmortissementArray because firebaseStore doesn't accept nested arrays
         */

        const tableauAmortissementArray =
            "tableauAmortissementArray" in this.outPutData
                ? JSON.parse(this.outPutData.tableauAmortissementArray)
                : [this.outPutData.tableauAmortissement];

        // compatibility layers for old bips that have only one crédite

        const creditBancaireArray = Array.isArray(
            this.investorProgramme.creditBancaire
        )
            ? this.investorProgramme.creditBancaire
            : [this.investorProgramme.creditBancaire];

        creditBancaireArray.forEach((creditBancaire, index) => {
            if (
                creditBancaire.montant !== 0 &&
                creditBancaire.montant !== null
            ) {
                this.creditExiste = true;
                this.chargeFinanciers.data.push([]);
                this.chargeFinanciers.data[index].push(`crédit ${index + 1}`);
                this.chargeFinanciers.data[index].push(creditBancaire.montant);
                this.chargeFinanciers.data[index].push(
                    creditBancaire.taux + "%"
                );
                this.chargeFinanciers.data[index].push(
                    tableauAmortissementArray[index].length
                );
                this.chargeFinanciers.data[index].push(
                    tableauAmortissementArray[index][
                        tableauAmortissementArray[index].length - 1
                    ].paiment
                );
                this.chargeFinanciers.data[index].push(
                    tableauAmortissementArray[index].reduce(
                        (accumulator, currentValue) => ({
                            partInterets:
                                accumulator.partInterets +
                                currentValue.partInterets
                        })
                    ).partInterets
                );
            }
        });

        this.cashFlow1.data[0].push("FLUX NETS DE TRESORERIE");
        this.cashFlow2.data[0].push("FLUX NETS DE TRESORERIE");
        this.cashFlow1.data[0].push(`-${this.investorProgramme.capital}`);
        this.cashFlow1.data[1].push("CUMUL");
        this.cashFlow2.data[1].push("CUMUL");
        this.cashFlow1.data[1].push(` `);
        this.outPutData.cpc.forEach((item, index) => {
            if (index >= 4) {
                this.cashFlow2.data[0].push(item.cashFlow);
                this.cashFlow2.data[1].push(
                    index === 0
                        ? this.outPutData.cpc[0].cashFlow
                        : this.Cumul(index)
                );
            } else {
                this.cashFlow1.data[0].push(item.cashFlow);
                this.cashFlow1.data[1].push(
                    index === 0
                        ? this.outPutData.cpc[0].cashFlow
                        : this.Cumul(index)
                );
            }
        });
    },
    computed: {
        Cumul() {
            return index => {
                return this.outPutData.cpc.reduce((a, b, i) => {
                    if (i > index) return a;
                    return a + b.cashFlow;
                }, 0);
            };
        }
    }
};
</script>

<style></style>
